import { useEffect } from 'react';
import { useRouter } from 'next/compat/router';

// Scrolls page to top when a route location change has been detected
function useRouterScroll({
  top = 0,
  left = 0,
  behavior = 'auto',
  disableScroll = false
} = {}) {
  const router = useRouter();
  useEffect(() => {
    if (router && !router.isReady) {
      return;
    }
    const hash = router.asPath.split('#')[1];

    // if there is a hash involved then we should let it control scroll position
    if (disableScroll || hash) {
      return;
    }
    window.scrollTo({
      top,
      left,
      behavior
    });
  }, [router, top, left, behavior, disableScroll]);
}

export { useRouterScroll };
